import { Node, mergeAttributes } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import CanvasNode from './CanvasNode.vue'

export default Node.create({
  name: 'canvas',
  group: 'block',
  inline: false,
  atom: true,

  addAttributes() {
    return {
      timestamp: {
        default: null,
        parseHTML: element => element.getAttribute('timestamp'),
        renderHTML: attributes => ({ timestamp: attributes.timestamp }),
      },
      canvasId: {
        default: null,
        parseHTML: element => element.getAttribute('canvas-id'),
        renderHTML: attributes => ({ 'canvas-id': attributes.canvasId }),
      },
      imageSource: {
        default: null,
        parseHTML: element => element.getAttribute('image-source'),
        renderHTML: attributes => ({ 'image-source': attributes.imageSource }),
      },
    }
  },

  parseHTML() {
    return [{ tag: 'canvas' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['canvas', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return VueNodeViewRenderer(CanvasNode)
  },
})
